import { gql } from '@apollo/client'

export const SEND_CONTACT_INFO_SMS_MUTATION = gql`
  mutation sendContactInfoSms($processingId: ID!) {
    sendContactInfoSms(processingId: $processingId)
  }
`
